/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {TrailerDoorStatus} from '@ion/core/src/types/entities';
import {dlsAlt} from '@ion/dls/src/theme/theme';
import ThemeIconProvider from './ThemeIconProvider';
import useIconDLS from './useIconDLS';

interface TrailerDoorStatusIconProps {
  status?: TrailerDoorStatus
}

/**
 * Defines the Design Language Trailer Rear Door Icon.
 *
 * ```typescript
 *    import {TrailerDoorStatusIcon} from '@ion/dls/src/icons/TrailerDoorStatusIcon';
 *
 *    <TrailerDoorStatusIcon status={doorStatus} />
 */
export const TrailerDoorStatusIcon = ({
  status
}: TrailerDoorStatusIconProps) => {
  const {iconColor} = useIconDLS({});
  return (
    <ThemeIconProvider name='TrailerDoorStatusIcon' color={iconColor} legacyIcon={(
      <svg width='103' height='168' viewBox='0 0 103 168' fill='none'>
        <g clipPath='url(#clip0)'>
          <path d='M102.261 1.57745H1.09332V126.337H102.261V1.57745Z' stroke={iconColor} strokeMiterlimit='10'/>
          <path d='M23.7114 126.076H1.09332V160.562H23.7114V126.076Z' stroke={iconColor} strokeMiterlimit='10'/>
          <path d='M101.08 126.076H78.4621V160.562H101.08V126.076Z' stroke={iconColor} strokeMiterlimit='10'/>
          <path d='M10.3412 161.113H1.34421V167.045H10.3412V161.113Z' stroke={iconColor} strokeMiterlimit='10'/>
          <path d='M21.7906 161.113H12.7937V167.045H21.7906V161.113Z' stroke={iconColor} strokeMiterlimit='10'/>
          <path d='M88.2709 161.113H79.2739V167.045H88.2709V161.113Z' stroke={iconColor} strokeMiterlimit='10'/>
          <path d='M99.9569 161.113H90.9599V167.045H99.9569V161.113Z' stroke={iconColor} strokeMiterlimit='10'/>
          <path d='M1.03442 119.685H102.055' stroke={iconColor} strokeMiterlimit='10'/>
          <path d='M58.8941 111.684H44.4605' stroke={iconColor} strokeMiterlimit='10'/>
          <path d='M69.4052 142.645V126.337H61.9003V142.645H38.78V126.337H31.2604V142.645H0.738556V145.48H101.877V142.645H69.4052Z'
            fill='#E0E0E0'
            stroke={iconColor} strokeMiterlimit='10'/>
          <rect opacity='0.2' x='0.867249' y='1.21832' width='100.953' height='118.13'
            fill={dlsAlt('colors', 'assets', status === TrailerDoorStatus.Open ? 'red' : 'cyan')} />
        </g>
        <defs>
          <clipPath id='clip0'>
            <rect width='103' height='167' fill='white' transform='translate(0 0.811035)'/>
          </clipPath>
        </defs>
      </svg>
    )} />
  );
};
